import Interaction from "../models/interactions/Interaction";

export function getKeysFromInteraction(
  obj: Interaction,
  prefix: string
): any[] {
  const results: string[] = [];

  function traverse(current: any) {
    if (current === null || current === undefined) return;

    if (typeof current === "string" && current.startsWith(prefix)) {
      results.push(current);
    }

    if (typeof current === "object") {
      if (Array.isArray(current)) {
        current.forEach((item) => traverse(item));
      } else {
        Object.values(current).forEach((value) => traverse(value));
      }
    }
  }

  traverse(obj);
  return results;
}
